import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import ReviewInfo from './review-info'
import ReviewInfoWithSellerFee from './reviewInfoWithSellerFee'
import { REVIEW_WITH_SELLER_FEE_VARIANTS } from '../../../../lib/constants'
import { tracking } from '../../lib/analytics/mParticle'
import Events from '../../lib/analytics/eventTags'

let PaymentDetails

class SendReviewInfo extends React.Component {
  static propTypes = {
    isPurchase: PropTypes.bool.isRequired,
    selectedFundingOption: PropTypes.object.isRequired,
    recipient: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    recipientCountry: PropTypes.string,
    selectedInstallmentPlan: PropTypes.object,
    showDonateContent: PropTypes.bool,
    isRecurring: PropTypes.bool,
    overpanelType: PropTypes.string,
    whoPaysFee: PropTypes.string,
    countryCode: PropTypes.string,
    language: PropTypes.string,
  }

  constructor(props) {
    super(props)
    if (REVIEW_WITH_SELLER_FEE_VARIANTS.includes(props.overpanelType)) {
      const {
        whoPaysFee,
        selectedFundingOption: { displayAmounts: { protectionFee } = {} } = {},
      } = this.props
      if (!protectionFee && whoPaysFee === 'senderPaysFee') {
        tracking(
          Events.p2p_non_visible_error_occurred({
            description: 'review_screen_no_protection_fees_returned',
            file_name: 'send-review-info',
            function_name: 'constructor',
          })
        )
        PaymentDetails = ReviewInfo
      } else {
        PaymentDetails = ReviewInfoWithSellerFee
      }
    } else {
      PaymentDetails = ReviewInfo
    }
  }

  render() {
    return (
      <PaymentDetails
        isPurchase={this.props.isPurchase}
        selectedFundingOption={this.props.selectedFundingOption}
        recipient={this.props.recipient}
        whoPaysFee={this.props.whoPaysFee}
        countryCode={this.props.countryCode}
        displayName={this.props.displayName}
        recipientCountry={this.props.recipientCountry}
        showDonateContent={this.props.showDonateContent}
        selectedInstallmentPlan={this.props.selectedInstallmentPlan}
        isRecurring={this.props.isRecurring}
        language={this.props.language}
      />
    )
  }
}

export default connect(
  ({ transaction, recipient, external, unilateral, amount, user }) => ({
    countryCode: user.country,
    language: user.language,
    isPurchase: transaction.isPurchase,
    selectedFundingOption: transaction.selectedFundingOption,
    recipient: recipient.recipient,
    overpanelType: recipient.moneyPageOverPanel,
    whoPaysFee: transaction.whoPaysFee,
    displayName: unilateral.name || recipient.displayName,
    recipientCountry: unilateral.countryCode,
    showDonateContent:
      external.showDonateContent || transaction.isCrowdFundingCampaign,
    isRecurring: external.isRecurring,
    // installments for BR and MX
    selectedInstallmentPlan: transaction.selectedInstallmentPlan,
  })
)(SendReviewInfo)
